export default __webpack_public_path__ + "static/media/mobileIcon.f545ffce.svg";